import { flatten } from 'lodash';

export function institutesSelector(provider) {
    const { properties = {} } = provider;
    const institute = properties.institutes;
    try {
        return institute && JSON.parse(institute);
    } catch (e) {
        return null;
    }
}

export function titlesFrom(provider) {
    const institutes = institutesSelector(provider);

    if (institutes) {
        const titles = flatten(institutes.map(i => i.providerTitles));
        return titles.filter(Boolean)[0];
    } else {
        return null;
    }
}
